(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7942],{

/***/ 40332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]",
      function () {
        return __webpack_require__(90748);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ExpandTransition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81041);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ExpandTransition = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div).attrs({
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
        open: {
            opacity: 1,
            height: "auto"
        },
        collapsed: {
            opacity: 0,
            height: 0
        }
    },
    transition: {
        duration: 0.3,
        ease: [
            0.04,
            0.62,
            0.23,
            0.98
        ]
    }
}).withConfig({
    displayName: "ExpandTransition",
    componentId: "sc-246d940-0"
})(_templateObject());


/***/ }),

/***/ 20516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ExpandButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78296);
/* harmony import */ var src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56647);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68251);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        transform: rotate(180deg);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  margin-bottom: 8px;\n  svg {\n    ",
        "\n    margin: 0 0 0 7px;\n    ",
        " {\n      margin: 0 7px 0 0;\n    }\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: auto;\n    ",
        " {\n      margin-right: 0;\n      margin-left: -20px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n  line-height: 18px;\n  text-transform: lowercase;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_2__/* .CleanButton */ .ux).withConfig({
    displayName: "ExpandButton__Button",
    componentId: "sc-81753a5-0"
})(_templateObject1(), function(param) {
    var $active = param.$active;
    return $active && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject());
}, src_styles_theme__WEBPACK_IMPORTED_MODULE_5__/* .dirRTL */ .gX, src_styles_theme__WEBPACK_IMPORTED_MODULE_5__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_4__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].p.withConfig({
    displayName: "ExpandButton__Text",
    componentId: "sc-81753a5-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
});
var ExpandButton = function(_param) {
    var active = _param.active, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "active",
        "onClick"
    ]);
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_8__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        $active: active,
        onClick: onClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                children: _(active ? "Read less" : "Read more")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_3__/* .ChevronBottom */ .B, {
                size: 13
            })
        ]
    }));
};


/***/ }),

/***/ 66660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ScrollToViewport; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _react_hook_merged_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27006);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30644);



var ScrollToViewport = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function ScrollToViewport(param, ref) {
    var children = param.children, active = param.active, options = param.options, scrollOnMount = param.scrollOnMount;
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var mergedRef = (0,_react_hook_merged_ref__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref, scrollRef);
    var hasChildren = !!children;
    var isFirstMount = (0,react_use__WEBPACK_IMPORTED_MODULE_2__/* .useFirstMountState */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((scrollOnMount || !isFirstMount) && active && hasChildren) {
            var _$ref;
            (_$ref = scrollRef.current) === null || _$ref === void 0 ? void 0 : _$ref.scrollIntoView(options !== null && options !== void 0 ? options : {
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        active,
        hasChildren
    ]);
    return children && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: mergedRef
    });
});


/***/ }),

/***/ 226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ StickyMenuSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var react_hook_inview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69671);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94829);
/* harmony import */ var src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95175);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Section = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].section.withConfig({
    displayName: "StickyMenuSection__Section",
    componentId: "sc-4d2b84b-0"
})(_templateObject());
var StickyMenuSection = function(_param) {
    var id = _param.id, label = _param.label, index = _param.index, threshold = _param.threshold, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "id",
        "label",
        "index",
        "threshold",
        "children"
    ]);
    var isDesktop = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("(min-width: 992px)", true);
    var activeThreshold = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (typeof threshold === "object" && !Array.isArray(threshold)) {
            if (isDesktop) return threshold.desktop;
            return threshold.mobile;
        }
        return threshold;
    }, [
        threshold,
        isDesktop
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,react_hook_inview__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .Y)({
        threshold: activeThreshold
    }), 2), ref1 = ref[0], isVisible = ref[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(src_components_common_StickyMenu_StickyMenuContext__WEBPACK_IMPORTED_MODULE_4__/* .StickyMenuContext */ .W), handleActiveSectionChange = ref2.handleActiveSectionChange, registerSection = ref2.registerSection;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isVisible) {
            handleActiveSectionChange(id);
        }
    }, [
        isVisible,
        handleActiveSectionChange,
        id
    ]);
    var hasChildren = !!children;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (id && label && hasChildren) {
            registerSection({
                id: id,
                label: label,
                index: index
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        label,
        hasChildren
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Section, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        ref: ref1,
        id: id !== null && id !== void 0 ? id : undefined,
        children: children
    }));
};


/***/ }),

/***/ 7040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LDJSON; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);




var LDJSON = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    "@context": "https://schema.org"
                }, props.data))
            }
        })
    });
});


/***/ }),

/***/ 29557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MetaCanonical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaCanonical(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: props.href
            }, "canonical"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: props.href
            }, "og:url")
        ]
    });
}


/***/ }),

/***/ 63884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ MetaImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function MetaImage(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.src
            }, "og:image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }, "twitter:card")
        ]
    });
}


/***/ }),

/***/ 78162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useFastRefreshFixer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Fixes fast refresh (or hot reload), has no effect on production.
 * Set returned value as key to the element you want to force-remount after refresh.
 */ function useFastRefreshFixer() {
    return  false ? 0 : undefined;
}


/***/ }),

/***/ 36311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useIsRTL; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useMutationObserver.ts

var useMutationObserver = function(domNodeSelector, callback, observerOptions) {
    (0,react.useEffect)(function() {
        var targetNode = document.querySelector(domNodeSelector);
        var observer = new MutationObserver(callback);
        if (targetNode) {
            observer.observe(targetNode, observerOptions);
        }
        return function() {
            observer.disconnect();
        };
    }, [
        domNodeSelector,
        observerOptions,
        callback
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useIsRTL.ts


var checkIsRTL = function() {
    return typeof document !== "undefined" ? document.documentElement.dir === "rtl" : false;
};
var options = {
    attributes: true
};
var useIsRTL = function() {
    var ref = (0,react.useState)(checkIsRTL), isRTL = ref[0], setIsRTL = ref[1];
    var handler = (0,react.useCallback)(function(mutationList) {
        mutationList.forEach(function() {
            setIsRTL(checkIsRTL);
        });
    }, []);
    useMutationObserver("html", handler, options);
    return isRTL;
};


/***/ }),

/***/ 59621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EventPageContext; },
/* harmony export */   "j": function() { return /* binding */ EventPageContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_hooks_useTimeState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12597);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19162);






var EventPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var EventPageContextProvider = function(param) {
    var event = param.event, children = param.children;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    var onStart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return queryClient.refetchQueries((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_4__/* .QueryKey.EventPage */ .S.EventPage).concat([
            event.slug
        ]));
    }, [
        event.slug,
        queryClient
    ]);
    var ref = (0,src_hooks_useTimeState__WEBPACK_IMPORTED_MODULE_2__/* .useTimeState */ .RA)(event, onStart), isUpcoming = ref.isUpcoming, isNow = ref.isNow, isCompleted = ref.isCompleted;
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            event: event,
            isNow: isNow,
            isUpcoming: isUpcoming,
            isCompleted: isCompleted
        };
    }, [
        event,
        isCompleted,
        isNow,
        isUpcoming
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EventPageContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 9059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ EventPageSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71508);
/* harmony import */ var vendor_utils_publicUrl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33403);
/* harmony import */ var src_components_seo_LDJSON__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7040);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38325);
/* harmony import */ var src_components_seo_MetaCanonical__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29557);
/* harmony import */ var src_components_seo_MetaImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63884);
/* harmony import */ var src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89080);
/* harmony import */ var src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70057);
/* harmony import */ var src_modules_events_hooks_useFlattenEvent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73082);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_services_directus_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6050);












var EventPageSEO = function(param) {
    var event = param.event;
    var ref, ref1, ref2;
    var flatEvent = (0,src_modules_events_hooks_useFlattenEvent__WEBPACK_IMPORTED_MODULE_9__/* .useFlattenEvent */ .p)(event);
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_11__.useTranslate)()._;
    var translateItem = (0,src_hooks_directus_useTranslateItem__WEBPACK_IMPORTED_MODULE_8__/* .useTranslateItem */ .L)();
    var canonicalUrl = (0,vendor_utils_publicUrl__WEBPACK_IMPORTED_MODULE_2__/* .publicUrl */ .$)(src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .route.event */ .BC.event(event).page());
    var imageUrl = flatEvent.seoImage ? (0,vendor_utils_publicUrl__WEBPACK_IMPORTED_MODULE_2__/* .publicUrl */ .$)((0,src_services_directus_common__WEBPACK_IMPORTED_MODULE_10__/* .getDirectusImageAssetUrl */ .yF)(flatEvent.seoImage.id, {
        width: 1200,
        height: 630,
        fit: "cover",
        format: "jpg"
    })) : undefined;
    var title = ((ref = flatEvent.type) === null || ref === void 0 ? void 0 : ref.name) ? "".concat((ref1 = flatEvent.type) === null || ref1 === void 0 ? void 0 : ref1.name, " ").concat(flatEvent.name) : flatEvent.name;
    var _excerpt;
    var description = (_excerpt = flatEvent.excerpt) !== null && _excerpt !== void 0 ? _excerpt : (ref2 = flatEvent.type) === null || ref2 === void 0 ? void 0 : ref2.excerpt;
    var meta = {
        "@type": "EducationEvent",
        name: title,
        description: description,
        startDate: flatEvent.startDate,
        endDate: flatEvent.endDate,
        url: canonicalUrl,
        image: imageUrl,
        performers: flatEvent.speakers ? flatEvent.speakers.map(function(t) {
            return t.people_id;
        }).map(translateItem).map(function(speaker) {
            return {
                "@type": "Person",
                jobTitle: [
                    speaker.degree,
                    speaker.title
                ].filter(function(v) {
                    return v;
                }),
                image: speaker.portrait ? (0,vendor_utils_publicUrl__WEBPACK_IMPORTED_MODULE_2__/* .publicUrl */ .$)((0,src_services_directus_common__WEBPACK_IMPORTED_MODULE_10__/* .getDirectusImageAssetUrl */ .yF)(speaker.portrait.id)) : undefined
            };
        }) : []
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_1__/* .MetaTitle */ .p, {
                children: _("Events - {eventName}", undefined, {
                    eventName: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_7__/* .MetaDescription */ .l, {
                children: _("Neauvia events, webinars, live streaming. {excerpt}", undefined, {
                    excerpt: description
                })
            }),
            imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaImage__WEBPACK_IMPORTED_MODULE_6__/* .MetaImage */ .w, {
                src: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_MetaCanonical__WEBPACK_IMPORTED_MODULE_5__/* .MetaCanonical */ .R, {
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_seo_LDJSON__WEBPACK_IMPORTED_MODULE_3__/* .LDJSON */ .w, {
                data: meta
            })
        ]
    });
};


/***/ }),

/***/ 72447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J2": function() { return /* binding */ useCurrentEventAgendaQuery; },
  "zF": function() { return /* binding */ useEventAgendaQuery; }
});

// UNUSED EXPORTS: fetchEventAgenda

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-agenda.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EventAgenda($filters: events_filter) {\n    events(filter: $filters) {\n      translations {\n        agendaDescription\n        languages_code {\n          code\n        }\n      }\n      subEvents {\n        id\n        guestLimit\n        requireRegistration\n        eventTimeslots {\n          id\n          startDate\n          endDate\n          eventParticipants_func {\n            count\n          }\n        }\n        speakers {\n          people_id {\n            name\n            avatar {\n              id\n            }\n          }\n        }\n        translations {\n          title\n          location\n          description\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventAgendaGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/events/components/EventPage/EventPageContext.tsx
var EventPageContext = __webpack_require__(59621);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventAgendaQuery.ts









var fetchEventAgenda = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, eventId) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!eventId) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventAgendaGqlQuery, {
                            filters: {
                                id: {
                                    _eq: eventId
                                }
                            }
                        }).then(function(d) {
                            var ref;
                            return (ref = d.events) === null || ref === void 0 ? void 0 : ref[0];
                        })
                    ];
            }
        });
    });
    return function fetchEventAgenda(apis, eventId) {
        return _ref.apply(this, arguments);
    };
}();
var useEventAgendaQuery = function(eventId) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.EventAgenda */.S.EventAgenda).concat([
        eventId
    ]), function() {
        return fetchEventAgenda(apis, eventId);
    }, {
        refetchInterval: 1000 * 60,
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true
    });
};
var useCurrentEventAgendaQuery = function() {
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    return useEventAgendaQuery(event.id);
};


/***/ }),

/***/ 43969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ useEventDetailsQuery; }
});

// UNUSED EXPORTS: fetchEventDetails

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/modules/events/graphql/events.fragment.ts
var events_fragment = __webpack_require__(67062);
// EXTERNAL MODULE: ./src/modules/videos/graphql/videos-basic.fragment.ts
var videos_basic_fragment = __webpack_require__(3273);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-details.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        '\n  query EventDetails($filters: events_filter, $sort: [String]) {\n    events(filter: $filters, sort: $sort, limit: -1) {\n      ...events\n      seoImage {\n        id\n      }\n      videos {\n        videos_id {\n          ...videosBasic\n        }\n      }\n      speakers {\n        people_id {\n          name\n          portrait {\n            id\n          }\n          translations {\n            title\n            degree\n            description\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n      subEvents {\n        id\n      }\n      faq(sort: ["sort"]) {\n        eventFaq_id {\n          translations {\n            answer\n            question\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var eventDetailsGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject(), events_fragment/* eventsGqlFragment */.g, videos_basic_fragment/* videosBasicFragment */.B);

;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventDetailsQuery.ts







var fetchEventDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, slug) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventDetailsGqlQuery, {
                            filters: {
                                slug: {
                                    _eq: slug
                                },
                                status: {
                                    _eq: "published"
                                }
                            }
                        }).then(function(a) {
                            return a.events[0];
                        })
                    ];
            }
        });
    });
    return function fetchEventDetails(apis, slug) {
        return _ref.apply(this, arguments);
    };
}();
var useEventDetailsQuery = function(slug, enabled) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.EventPage */.S.EventPage).concat([
        slug
    ]), function() {
        return fetchEventDetails(apis, slug);
    }, {
        enabled: enabled
    });
};


/***/ }),

/***/ 98310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useEventRelatedVideosListQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_modules_videos_graphql_videos_basic_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77336);
/* harmony import */ var src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68591);
/* harmony import */ var src_modules_videos_hooks_useVideosListQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24332);




var useEventRelatedVideosListQuery = function(param) {
    var event = param.event, _limit = param.limit, limit = _limit === void 0 ? -1 : _limit, _detailed = param.detailed, detailed = _detailed === void 0 ? false : _detailed;
    var ref;
    var tagsIDs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref1;
        return (ref = event === null || event === void 0 ? void 0 : (ref1 = event.tags) === null || ref1 === void 0 ? void 0 : ref1.map(function(tag) {
            return tag.tags_id.id;
        }).slice(0, 1)) !== null && ref !== void 0 ? ref : [];
    }, [
        event === null || event === void 0 ? void 0 : event.tags
    ]);
    var videos = (0,src_modules_videos_hooks_useVideosListQuery__WEBPACK_IMPORTED_MODULE_3__/* .useVideosListQuery */ .L)(detailed ? src_modules_videos_graphql_videos_details_query__WEBPACK_IMPORTED_MODULE_2__/* .videoDetailsGqlQuery */ .W : src_modules_videos_graphql_videos_basic_query__WEBPACK_IMPORTED_MODULE_1__/* .videosBasicGqlQuery */ .g, {
        filters: {
            tags: {
                tags_id: {
                    id: {
                        _in: tagsIDs
                    }
                }
            },
            status: {
                _eq: "published"
            },
            showcase: {
                _eq: true
            }
        },
        limit: limit,
        sort: [
            "-date_created"
        ]
    }, {
        enabled: tagsIDs.length > 0
    });
    return videos;
};


/***/ }),

/***/ 95224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useEventTicketQuery; }
/* harmony export */ });
/* unused harmony export fetchEventTicket */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53100);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);
/* harmony import */ var src_modules_user_hooks_useUserQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44320);







var fetchEventTicket = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(apis, eventId) {
        var directus;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.api.tickets.get(eventId)
                    ];
            }
        });
    });
    return function fetchEventTicket(apis, eventId) {
        return _ref.apply(this, arguments);
    };
}();
var useEventTicketQuery = function(eventId) {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_1__/* .useAPIs */ .V)();
    var ref = (0,src_modules_user_hooks_useUserQuery__WEBPACK_IMPORTED_MODULE_3__/* .useUserQuery */ .b)(), user = ref.data;
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.EventTicket */ .S.EventTicket).concat([
        eventId
    ]), function() {
        return fetchEventTicket(apis, eventId);
    }, {
        enabled: !!user
    });
};


/***/ }),

/***/ 45499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ Showcase; }
/* harmony export */ });
/* unused harmony exports ShowcaseTitle, ShowcaseSubtitle */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68251);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52520);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38108);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12732);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12258);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 8px;\n  }\n  ",
        " {\n    position: absolute;\n    opacity: 0;\n    transform: translateX(-15px);\n    transition: 0.15s;\n    right: -6px;\n    bottom: 10px;\n    svg {\n      height: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 270px;\n  padding: 24px 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: flex-start;\n  color: ",
        ";\n  text-align: left;\n  background: ",
        ";\n  ",
        " {\n    text-align: right;\n  }\n\n  ",
        " {\n    height: 577px;\n    padding: 50px 24px;\n    &:hover {\n      ",
        " {\n        opacity: 1;\n        transform: translateX(0);\n      }\n    }\n  }\n\n  &:nth-child(2) {\n    margin-top: -30px;\n  }\n\n  &:nth-child(3) {\n    margin-top: 30px;\n  }\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      0deg,\n      rgba(22, 22, 22, 0.4) 11%,\n      rgba(200, 201, 201, 0) 42%,\n      rgba(201, 201, 201, 0) 71%,\n      rgba(192, 202, 199, 0) 100%,\n      rgba(25, 27, 26, 0) 100%\n    );\n    z-index: 2;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 110%;\n\n  ",
        " {\n    font-size: 26px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 110%;\n  margin-top: 10px;\n  ",
        ";\n\n  ",
        " {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        padding-right: 20px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 1;\n  max-width: 100%;\n  word-wrap: break-word;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n\n  ",
        " {\n    object-position: center center;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var ChevronWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__ChevronWrapper",
    componentId: "sc-e6e44700-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].a.withConfig({
    displayName: "Showcase__Wrapper",
    componentId: "sc-e6e44700-1"
})(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.gray6;
}), function(param) {
    var theme = param.theme;
    return theme.palette.neauvia;
}, src_styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, ChevronWrapper);
var ShowcaseTitle = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].h4.withConfig({
    displayName: "Showcase__ShowcaseTitle",
    componentId: "sc-e6e44700-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var ShowcaseSubtitle = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__ShowcaseSubtitle",
    componentId: "sc-e6e44700-3"
})(_templateObject3(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_9__/* .lineClamp */ .Sf)(4), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div.withConfig({
    displayName: "Showcase__Content",
    componentId: "sc-e6e44700-4"
})(_templateObject5(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_8__/* .casePathEmptyString */ .Q)("$withChevron")((0,styled_components__WEBPACK_IMPORTED_MODULE_10__.css)(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop)));
var BackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])((next_image__WEBPACK_IMPORTED_MODULE_4___default())).withConfig({
    displayName: "Showcase__BackgroundImage",
    componentId: "sc-e6e44700-5"
})(_templateObject6(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var Showcase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_6__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var image = _param.image, title = _param.title, subtitle = _param.subtitle, withChevron = _param.withChevron, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "image",
        "title",
        "subtitle",
        "withChevron",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props), {
        ref: ref,
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImage, {
                as: src_components_common_DirectusImage__WEBPACK_IMPORTED_MODULE_5__/* .DirectusImage */ .q,
                src: image,
                layout: "fill"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Content, {
                $withChevron: withChevron,
                children: children || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShowcaseTitle, {
                            children: title
                        }),
                        title && subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShowcaseSubtitle, {
                            children: subtitle
                        }),
                        withChevron && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ChevronWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_7__/* .ChevronRight */ ._, {
                                width: 24,
                                height: 14
                            })
                        })
                    ]
                })
            })
        ]
    }));
});
Showcase.displayName = "Showcase";


/***/ }),

/***/ 86649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ SliderSectionRender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_hooks_dev_useFastRefreshFixer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78162);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52178);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72873);
/* harmony import */ var src_modules_materials_components_Thumbnail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87847);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68251);
/* harmony import */ var src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18709);
/* harmony import */ var src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38108);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87379);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78296);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12258);
/* harmony import */ var src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79017);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(38325);
/* harmony import */ var src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47536);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_hooks_useIsRTL__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36311);
/* harmony import */ var src_modules_materials_providers_TaxonomyContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(74729);
/* harmony import */ var src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(54095);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(81041);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(14332);
/* harmony import */ var src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(84176);
/* harmony import */ var src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(12230);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: var(--results-left-margin);\n  padding-right: calc(var(--constraint-container-right-margin) - 20px);\n  ",
        " {\n    padding-left: calc(var(--constraint-container-right-margin) - 20px);\n    padding-right: var(--results-left-margin);\n  }\n\n  .swiper-slide {\n    width: 264px;\n    min-height: 220px;\n    margin-right: 20px;\n    ",
        " {\n      margin-right: 0;\n      margin-left: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  margin: 0 calc(-1 * var(--results-right-margin)) 40px\n    calc(-1 * var(--results-left-margin));\n  ",
        " {\n    opacity: 0;\n  }\n  &:hover > ",
        " {\n    opacity: 1;\n  }\n  ",
        " {\n    margin: 0 calc(-1 * var(--results-left-margin)) 42px\n      calc(-1 * var(--results-right-margin));\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
























var StyledSwiper = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .t).withConfig({
    displayName: "SliderSectionRender__StyledSwiper",
    componentId: "sc-b208bfaf-0"
})(_templateObject(), src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX, src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX);
var SkeletonSlide = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_23__/* .motion.div */ .E.div).withConfig({
    displayName: "SliderSectionRender__SkeletonSlide",
    componentId: "sc-b208bfaf-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
});
var SwiperArea = styled_components__WEBPACK_IMPORTED_MODULE_22__["default"].div.withConfig({
    displayName: "SliderSectionRender__SwiperArea",
    componentId: "sc-b208bfaf-2"
})(_templateObject2(), src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX);
var SeeAllContainer = styled_components__WEBPACK_IMPORTED_MODULE_22__["default"].div.withConfig({
    displayName: "SliderSectionRender__SeeAllContainer",
    componentId: "sc-b208bfaf-3"
})(_templateObject3(), (0,src_styles_common__WEBPACK_IMPORTED_MODULE_12__.ar)(16 / 9));
var SeeAllButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_22__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx).withConfig({
    displayName: "SliderSectionRender__SeeAllButton",
    componentId: "sc-b208bfaf-4"
})(_templateObject4());
var SliderSectionRender = function(param) {
    var section = param.section, items = param.items, event = param.event, _header = param.header, header = _header === void 0 ? true : _header, isLoading = param.isLoading;
    var ref, ref1;
    var key = (0,src_hooks_dev_useFastRefreshFixer__WEBPACK_IMPORTED_MODULE_2__/* .useFastRefreshFixer */ .P)();
    var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), swiper = ref2[0], setSwiper = ref2[1];
    var thumbnailOptions = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(src_modules_materials_providers_ShowcaseContext__WEBPACK_IMPORTED_MODULE_19__/* .ShowcaseContext */ .r).thumbnailOptions;
    var isRTL = (0,src_hooks_useIsRTL__WEBPACK_IMPORTED_MODULE_17__/* .useIsRTL */ .S)();
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_24__.useTranslate)()._;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
            swiper.navigation.init();
            swiper.navigation.update();
        }
    }, [
        swiper
    ]);
    var hasItems = isLoading || items != null && items.length > 0;
    var loading = (0,src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_21__/* .useDelayedValue */ .t)(isLoading, 500);
    var shouldDisplaySeeAllBtn = !!(section.searchQuery && ((ref = section.variables) === null || ref === void 0 ? void 0 : ref.limit) && items && items.length >= section.variables.limit);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_modules_materials_providers_TaxonomyContext__WEBPACK_IMPORTED_MODULE_18__/* .TaxonomyContext.Provider */ .u.Provider, {
        value: section.taxonomy,
        children: [
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .GenericSectionHeader */ .O, {
                section: section
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperArea, {
                children: hasItems && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSwiper, {
                            threshold: 15,
                            onSwiper: setSwiper,
                            slidesPerView: "auto",
                            watchSlidesProgress: true,
                            navigation: {
                                prevEl: prevRef.current,
                                nextEl: nextRef.current
                            },
                            wrapperTag: "ul",
                            children: [
                                (ref1 = items !== null && items !== void 0 ? items : lodash_range__WEBPACK_IMPORTED_MODULE_16___default()(5)) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o, {
                                        tag: "li",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_25__/* .AnimatePresence */ .M, {
                                            children: [
                                                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonSlide, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, (0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_20__/* .makeTransition */ .Vr)({
                                                    fade: true
                                                })), {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__/* .Skeleton */ .O, {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Skeleton__WEBPACK_IMPORTED_MODULE_15__/* .Skeleton */ .O, {
                                                            style: {
                                                                marginTop: 14
                                                            },
                                                            width: "60%",
                                                            height: "20px"
                                                        })
                                                    ]
                                                }), "skeleton-".concat(i)),
                                                typeof item !== "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_Thumbnail__WEBPACK_IMPORTED_MODULE_6__/* .Thumbnail */ .$, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({
                                                    item: item,
                                                    event: event,
                                                    uniqueId: item.id + section.name
                                                }, thumbnailOptions))
                                            ]
                                        })
                                    }, i);
                                }),
                                section.searchQuery && shouldDisplaySeeAllBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o, {
                                    tag: "li",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SeeAllContainer, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_TrackedLink__WEBPACK_IMPORTED_MODULE_13__/* .TrackedLink */ .A, {
                                            href: src_services_route__WEBPACK_IMPORTED_MODULE_14__/* .route.search */ .BC.search(section.searchQuery).all(true),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SeeAllButton, {
                                                forwardedAs: "a",
                                                icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__/* .ChevronRight */ ._,
                                                iconProps: {
                                                    position: "right",
                                                    size: 12
                                                },
                                                children: _("See all")
                                            })
                                        })
                                    })
                                })
                            ]
                        }, key),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__/* .Theme */ .Q, {
                            theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .darkTheme */ .$_,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, {
                                    kind: "circled",
                                    ref: prevRef,
                                    icon: src_components_icons_ChevronLeft__WEBPACK_IMPORTED_MODULE_9__/* .ChevronLeft */ .s,
                                    $direction: "left"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_modules_materials_components_ShowcasePage_common__WEBPACK_IMPORTED_MODULE_4__/* .NavigationButton */ .W, {
                                    kind: "circled",
                                    ref: nextRef,
                                    icon: src_components_icons_ChevronRight__WEBPACK_IMPORTED_MODULE_10__/* .ChevronRight */ ._,
                                    $direction: "right"
                                })
                            ]
                        })
                    ]
                })
            }, String(isRTL) + key)
        ]
    });
};


/***/ }),

/***/ 61012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ speakersGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment speakers on people {\n    id\n    avatar {\n      id\n    }\n    name\n    translations {\n      degree\n      title\n      languages_code {\n        code\n      }\n    }\n    country {\n      translations {\n        languages_code {\n          code\n        }\n        name\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var speakersGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 3273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ videosBasicFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment videosBasic on videos {\n    id\n    slug\n    date_created\n    thumbnail {\n      id\n    }\n    bodyParts {\n      bodyParts_id {\n        slug\n      }\n    }\n    subjects {\n      subjects_id {\n        slug\n      }\n    }\n    tags {\n      tags_id {\n        id\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    disclaimer\n    source {\n      id\n      url\n      format\n      duration\n      startDate\n      endDate\n    }\n    translations {\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var videosBasicFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 77336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ videosBasicGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);
/* harmony import */ var src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3273);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  query VideoBasicQuery($filters: videos_filter, $sort: [String], $limit: Int) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      ...videosBasic\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var videosBasicGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), src_modules_videos_graphql_videos_basic_fragment__WEBPACK_IMPORTED_MODULE_2__/* .videosBasicFragment */ .B);


/***/ }),

/***/ 68591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ videoDetailsGqlQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61012);
/* harmony import */ var src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70763);
/* harmony import */ var src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39738);
/* harmony import */ var src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67561);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n\n  query VideoDetailsQuery(\n    $filters: videos_filter\n    $sort: [String]\n    $limit: Int\n  ) {\n    videos(filter: $filters, sort: $sort, limit: $limit) {\n      id\n      slug\n      date_created\n\n      bodyParts {\n        bodyParts_id {\n          slug\n        }\n      }\n      subjects {\n        subjects_id {\n          slug\n        }\n      }\n      translations {\n        languages_code {\n          code\n        }\n        name\n        description\n        excerpt\n      }\n      audioLanguages {\n        languages_code {\n          code\n          name\n        }\n      }\n      thumbnail {\n        id\n      }\n      products {\n        products_id {\n          ...products\n        }\n      }\n      disclaimer\n      source {\n        id\n        url\n        format\n        duration\n        startDate\n        endDate\n      }\n      tags {\n        tags_id {\n          ...tags\n        }\n      }\n      shortcodes {\n        ...shortcodes\n      }\n      speakers {\n        people_id {\n          ...speakers\n        }\n      }\n      attachments {\n        attachments_id {\n          id\n          type\n          translations {\n            name\n            url\n            description\n            file {\n              id\n            }\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var videoDetailsGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_5__/* .gql */ .Ps)(_templateObject(), src_modules_products_graphql_products_fragment__WEBPACK_IMPORTED_MODULE_3__/* .productsGqlFragment */ .f, src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_4__/* .shortcodesGqlFragment */ .U, src_modules_materials_graphql_speakers_fragment__WEBPACK_IMPORTED_MODULE_1__/* .speakersGqlFragment */ .v, src_modules_materials_graphql_tags_fragment__WEBPACK_IMPORTED_MODULE_2__/* .tagsGqlFragment */ .i);


/***/ }),

/***/ 24332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useVideosListQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53100);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);






var useVideosListQuery = function(query, variables, options) {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_0__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.VideoList */ .S.VideoList).concat([
        query,
        variables
    ]), /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var directus;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(query, variables).then(function(d) {
                            return d.videos.filter(function(v) {
                                return v;
                            });
                        })
                    ];
            }
        });
    }), options);
};


/***/ }),

/***/ 90748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; },
  "getSitemap": function() { return /* binding */ getSitemap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/modules/events/components/EventPage/EventPageContext.tsx
var EventPageContext = __webpack_require__(59621);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/modules/events/components/EventCountdown.tsx
var EventCountdown = __webpack_require__(44558);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/components/common/typography/Header.tsx
var Header = __webpack_require__(29894);
// EXTERNAL MODULE: ./src/modules/events/hooks/useFlattenEvent.ts
var useFlattenEvent = __webpack_require__(73082);
// EXTERNAL MODULE: ./src/components/icons/Share.tsx
var Share = __webpack_require__(47727);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/utils/casePathEmptyString.ts
var casePathEmptyString = __webpack_require__(12732);
// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
// EXTERNAL MODULE: ./src/modules/events/hooks/useIsMultidayEvent.ts
var useIsMultidayEvent = __webpack_require__(80141);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderContent/EventPageHeaderContentDate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: flex;\n    gap: 8px;\n    align-items: flex-end;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  font-weight: bold;\n  letter-spacing: 0.08em;\n  ",
        " {\n    font-size: 21px;\n    line-height: 21px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.08em;\n  ",
        " {\n    font-size: 14px;\n    line-height: 18px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContentDate__Container",
    componentId: "sc-e3b3c139-0"
})(_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var DateText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContentDate__DateText",
    componentId: "sc-e3b3c139-1"
})(_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Time = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContentDate__Time",
    componentId: "sc-e3b3c139-2"
})(_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageHeaderContentDate = function() {
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,react.useContext)(EventPageContext/* EventPageContext */.P), event = ref.event, isNow = ref.isNow;
    var ref1 = (0,useIsMultidayEvent/* useIsMultidayEvent */.U)(event), isMultiDayEvent = ref1.isMultiDayEvent, displayStartDateMonth = ref1.displayStartDateMonth;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateText, {
                children: isMultiDayEvent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                            format: displayStartDateMonth ? "dd.LL" : "dd",
                            children: event.startDate
                        }),
                        "-",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                            format: "dd.LL",
                            children: event.endDate
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                    format: "dd.LL",
                    children: event.startDate
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                children: isMultiDayEvent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: isNow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            _("Ends on"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                                format: "dd.LL",
                                children: event.endDate
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                children: event.endDate
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            _("Starts at"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                children: event.startDate
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                            children: event.startDate
                        }),
                        "-",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                            children: event.endDate
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/components/common/ShareOverlay.tsx + 5 modules
var ShareOverlay = __webpack_require__(52575);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/components/icons/Calendar.tsx
var Calendar = __webpack_require__(66105);
// EXTERNAL MODULE: ./src/components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(38108);
// EXTERNAL MODULE: ./src/modules/events/components/UserEvents/UserEventsEventButton.tsx
var UserEventsEventButton = __webpack_require__(46855);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderContent/EventPageHeaderContentCTAs.tsx

function EventPageHeaderContentCTAs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  max-width: 500px;\n  gap: 8px;\n\n  margin-top: 24px;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n"
    ]);
    EventPageHeaderContentCTAs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageHeaderContentCTAs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 1;\n    margin: 12px 4px 0;\n    min-width: max-content !important;\n    max-width: max-content !important;\n  "
    ]);
    EventPageHeaderContentCTAs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageHeaderContentCTAs_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: -1;\n  ",
        "\n"
    ]);
    EventPageHeaderContentCTAs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var EventPageHeaderContentCTAs_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContentCTAs__Container",
    componentId: "sc-623342ab-0"
})(EventPageHeaderContentCTAs_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var CalendarButton = (0,styled_components_browser_esm["default"])(Button/* FullWidthButton */.Ow).withConfig({
    displayName: "EventPageHeaderContentCTAs__CalendarButton",
    componentId: "sc-623342ab-1"
})(EventPageHeaderContentCTAs_templateObject2(), (0,casePathEmptyString/* casePathEmptyString */.Q)("$short")((0,styled_components_browser_esm.css)(EventPageHeaderContentCTAs_templateObject1())));
var EventPageHeaderContentCTAs = function() {
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,react.useContext)(EventPageContext/* EventPageContext */.P), event = ref.event, isUpcoming = ref.isUpcoming;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var hasUpcomingCtaLink = !!(flatEvent.upcomingCtaLink && flatEvent.upcomingCtaLabel);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderContentCTAs_Container, {
        children: [
            hasUpcomingCtaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* FullWidthButton */.Ow, {
                variant: "secondary",
                forwardedAs: "a",
                href: flatEvent.upcomingCtaLink,
                icon: ChevronRight/* ChevronRight */._,
                iconProps: {
                    position: "right",
                    size: 12
                },
                children: flatEvent.upcomingCtaLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserEventsEventButton/* UserEventsEventButton */.J, {
                event: event,
                variant: !hasUpcomingCtaLink && !isUpcoming ? "secondary" : "primary"
            }),
            isUpcoming && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarButton, {
                forwardedAs: "a",
                $short: hasUpcomingCtaLink,
                kind: hasUpcomingCtaLink ? "text" : "default",
                variant: hasUpcomingCtaLink ? "primary" : "secondary",
                href: route/* route.event */.BC.event(event).ics(),
                icon: Calendar/* default */.Z,
                iconProps: {
                    position: hasUpcomingCtaLink ? "left" : "right",
                    size: 12
                },
                children: _("Add to calendar")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderContent/index.tsx

function EventPageHeaderContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-bottom: 0 !important;\n      "
    ]);
    EventPageHeaderContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageHeaderContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-top: 10px;\n  padding-bottom: 30px;\n  color: ",
        ";\n  ",
        " {\n    padding-bottom: 70px;\n    ",
        "\n  }\n"
    ]);
    EventPageHeaderContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageHeaderContent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &&& {\n    width: 100%;\n    display: grid;\n    position: static;\n    bottom: auto;\n    right: auto;\n    transform: none;\n\n    ",
        " {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n"
    ]);
    EventPageHeaderContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 18px;\n  gap: 20px;\n  ",
        " {\n    flex-direction: row;\n    padding-bottom: 24px;\n    align-items: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  line-height: 32px;\n  font-weight: 300;\n  max-width: 270px;\n  margin: 0;\n  padding-left: 0;\n  span {\n    display: block;\n    font-weight: 250;\n  }\n  &:before {\n    content: none;\n  }\n  ",
        " {\n    letter-spacing: 0.02em;\n    line-height: 36px;\n    max-width: 450px;\n    padding-left: 46px;\n    &:before {\n      content: '';\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-wrap: break-word;\n  display: flex;\n  align-items: ",
        ";\n  gap: 15px;\n  ",
        " {\n    gap: 9px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 11px;\n  font-size: 12px;\n  line-height: 21px;\n  font-weight: 600;\n  text-transform: uppercase;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  letter-spacing: 1px;\n  opacity: 0.7;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  letter-spacing: 0.08em;\n  font-size: 21px;\n  line-height: 21px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  ",
        " {\n    margin-bottom: 0;\n    font-weight: 300;\n    font-size: 32px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 122px;\n  height: 45px;\n  margin-bottom: 36px;\n  ",
        " {\n    width: 162px;\n    height: 64px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


















var EventPageHeaderContent_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__Container",
    componentId: "sc-99c49569-0"
})(EventPageHeaderContent_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,casePathEmptyString/* casePathEmptyString */.Q)("$short")((0,styled_components_browser_esm.css)(EventPageHeaderContent_templateObject())));
var StyledEventCountdown = (0,styled_components_browser_esm["default"])(EventCountdown/* EventCountdown */.e).withConfig({
    displayName: "EventPageHeaderContent__StyledEventCountdown",
    componentId: "sc-99c49569-1"
})(EventPageHeaderContent_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__Content",
    componentId: "sc-99c49569-2"
})(_templateObject3());
var EventPageHeaderContent_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__Header",
    componentId: "sc-99c49569-3"
})(_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Heading = (0,styled_components_browser_esm["default"])(Header.H1).withConfig({
    displayName: "EventPageHeaderContent__Heading",
    componentId: "sc-99c49569-4"
})(_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var HeadingContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__HeadingContainer",
    componentId: "sc-99c49569-5"
})(_templateObject6(), function(param) {
    var $centerItems = param.$centerItems;
    return $centerItems ? "center" : "flex-start";
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Details = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__Details",
    componentId: "sc-99c49569-6"
})(_templateObject7());
var FormContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__FormContainer",
    componentId: "sc-99c49569-7"
})(_templateObject8());
var ReachText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__ReachText",
    componentId: "sc-99c49569-8"
})(_templateObject9());
var StatusText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__StatusText",
    componentId: "sc-99c49569-9"
})(_templateObject10(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var LogoContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderContent__LogoContainer",
    componentId: "sc-99c49569-10"
})(_templateObject11(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHeaderContent = function() {
    var ref, ref1;
    var _ = (0,lib.useTranslate)()._;
    var ref2 = (0,react.useState)(false), shareOverlay = ref2[0], setShareOverlay = ref2[1];
    var ref3 = (0,react.useContext)(EventPageContext/* EventPageContext */.P), event = ref3.event, isUpcoming = ref3.isUpcoming, isCompleted = ref3.isCompleted;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: shareOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOverlay/* ShareOverlay */.Hs, {
                    titles: true,
                    close: function() {
                        return setShareOverlay(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderContent_Container, {
                $short: !isUpcoming,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            isUpcoming && flatEvent.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                                    src: flatEvent.logo.id,
                                    layout: "fill",
                                    objectFit: "contain",
                                    objectPosition: "0 50%"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderContent_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Details, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: flatEvent.form
                                                    }),
                                                    flatEvent.reach && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReachText, {
                                                                children: "|"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReachText, {
                                                                children: flatEvent.reach
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !isUpcoming ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusText, {
                                                children: _(isCompleted ? "ended" : "now")
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeaderContentDate, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingContainer, {
                                        $centerItems: !((ref = flatEvent.type) === null || ref === void 0 ? void 0 : ref.name),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                                children: [
                                                    (ref1 = flatEvent.type) === null || ref1 === void 0 ? void 0 : ref1.name,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: flatEvent.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                                onClick: function() {
                                                    return setShareOverlay(true);
                                                },
                                                kind: "circled",
                                                size: "small",
                                                icon: Share/* default */.Z
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeaderContentCTAs, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEventCountdown, {
                        event: event
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useRectMeasure.ts
var useRectMeasure = __webpack_require__(48101);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/modules/events/models/eventPage.ts
var EventPageSection;
(function(EventPageSection) {
    EventPageSection["About"] = "about";
    EventPageSection["Agenda"] = "agenda";
    EventPageSection["Speakers"] = "speakers";
    EventPageSection["RelatedVideos"] = "related-videos";
    EventPageSection["FAQ"] = "faq";
})(EventPageSection || (EventPageSection = {}));

// EXTERNAL MODULE: ./src/components/common/StickyMenu/index.tsx
var StickyMenu = __webpack_require__(25196);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageStickyMenu.tsx



function EventPageStickyMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &&& {\n    .sticky-menu__button {\n      justify-content: start;\n      min-width: 116px;\n      ",
        " {\n        min-width: 170px;\n      }\n    }\n  }\n"
    ]);
    EventPageStickyMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var stickyMenuSections = [
    {
        id: EventPageSection.About,
        label: "ABOUT"
    },
    {
        id: EventPageSection.Agenda,
        label: "agenda"
    },
    {
        id: EventPageSection.Speakers,
        label: "speakers"
    },
    {
        id: EventPageSection.RelatedVideos,
        label: "videos"
    },
    {
        id: EventPageSection.FAQ,
        label: "faq"
    }, 
];
var StyledStickyMenu = (0,styled_components_browser_esm["default"])(StickyMenu/* StickyMenu */.a).withConfig({
    displayName: "EventPageStickyMenu__StyledStickyMenu",
    componentId: "sc-9b88421f-0"
})(EventPageStickyMenu_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageStickyMenu = function(_param) {
    var event = _param.event, props = (0,_object_without_properties/* default */.Z)(_param, [
        "event"
    ]);
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var filteredStickyMenuSections = (0,react.useMemo)(function() {
        return stickyMenuSections.filter(function(param) {
            var id = param.id;
            if (id === EventPageSection.Speakers) {
                return flatEvent.speakers.length > 0;
            }
            if (id === EventPageSection.Agenda) {
                var ref;
                return !!((ref = flatEvent.subEvents) === null || ref === void 0 ? void 0 : ref.length);
            }
            if (id === EventPageSection.FAQ) {
                var ref1;
                return ((ref1 = flatEvent.faq) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
            }
            if (id === EventPageSection.RelatedVideos) {
                var ref2;
                return ((ref2 = flatEvent.tags) === null || ref2 === void 0 ? void 0 : ref2.length) > 0;
            }
            return true;
        });
    }, [
        flatEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStickyMenu, (0,_object_spread/* default */.Z)({
        tabs: filteredStickyMenuSections,
        transparentOnTop: true
    }, props));
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeaderSection/index.tsx


function EventPageHeaderSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: 235px !important;\n      padding-bottom: 12px;\n      ",
        " {\n        padding-bottom: 30px;\n      }\n    "
    ]);
    EventPageHeaderSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageHeaderSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 404px;\n  background: ",
        ";\n\n  ",
        " {\n    min-height: 528px;\n    ",
        " {\n      max-width: 1100px;\n    }\n  }\n  ",
        "\n"
    ]);
    EventPageHeaderSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageHeaderSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1100px;\n  flex: 1;\n  display: flex;\n"
    ]);
    EventPageHeaderSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageHeaderSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: 20% top;\n  overflow: visible;\n\n  ",
        " {\n    object-fit: contain;\n    object-position: 70% center;\n    ",
        " {\n      object-position: 0% center;\n    }\n  }\n  ",
        " {\n    right: -30vw !important;\n  }\n"
    ]);
    EventPageHeaderSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var EventPageHeaderSection_Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "EventPageHeaderSection__Header",
    componentId: "sc-814492bd-0"
})(EventPageHeaderSection_templateObject1(), function(param) {
    var theme = param.theme, $background = param.$background;
    return $background !== null && $background !== void 0 ? $background : theme.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, ConstraintContainer/* ConstraintContainer */.a, (0,casePathEmptyString/* casePathEmptyString */.Q)("$short")((0,styled_components_browser_esm.css)(EventPageHeaderSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop)));
var EventPageHeaderSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageHeaderSection__Container",
    componentId: "sc-814492bd-1"
})(EventPageHeaderSection_templateObject2());
var BackgroundImage = (0,styled_components_browser_esm["default"])(DirectusImage/* DirectusImage */.q).withConfig({
    displayName: "EventPageHeaderSection__BackgroundImage",
    componentId: "sc-814492bd-2"
})(EventPageHeaderSection_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageHeaderSection = function() {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useRectMeasure/* useRectMeasure */.R)(), 2), bannerRef = ref2[0], height = ref2[1];
    var ref3 = (0,react.useContext)(EventPageContext/* EventPageContext */.P), event = ref3.event, isNow = ref3.isNow, isCompleted = ref3.isCompleted;
    var _image;
    var backgroundImage = (_image = event.image) !== null && _image !== void 0 ? _image : (ref = event.type) === null || ref === void 0 ? void 0 : ref.image;
    var _background;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderSection_Header, {
        ref: bannerRef,
        $short: isNow || isCompleted,
        $background: (_background = event.background) !== null && _background !== void 0 ? _background : (ref1 = event.type) === null || ref1 === void 0 ? void 0 : ref1.background,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageStickyMenu, {
                event: event,
                bannerHeight: height
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderSection_Container, {
                children: [
                    backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage, {
                        src: backgroundImage.id,
                        layout: "fill"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeaderContent, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeading.tsx

function EventPageHeading_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  min-height: 60px;\n\n  ",
        " {\n    padding-left: 40px;\n  }\n"
    ]);
    EventPageHeading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var EventPageHeading = (0,styled_components_browser_esm["default"])(Header.H1).attrs({
    as: "h2"
}).withConfig({
    displayName: "EventPageHeading",
    componentId: "sc-be06d4d2-0"
})(EventPageHeading_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAboutSection/index.tsx

function EventPageAboutSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0 34px;\n  background: ",
        ";\n  ",
        " {\n    padding: 54px 0 76px;\n  }\n"
    ]);
    EventPageAboutSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1020px;\n  ",
        " {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n"
    ]);
    EventPageAboutSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n  width: 100%;\n  max-width: 650px;\n  color: ",
        ";\n  ",
        " {\n    font-size: 14px;\n    line-height: 21px;\n    padding-top: 16px;\n  }\n"
    ]);
    EventPageAboutSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  ",
        " {\n    opacity: 0.6;\n  }\n"
    ]);
    EventPageAboutSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 120%;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  color: ",
        ";\n"
    ]);
    EventPageAboutSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 10px;\n"
    ]);
    EventPageAboutSection_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EventPageAboutSection_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n"
    ]);
    EventPageAboutSection_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageAboutSection__Section",
    componentId: "sc-1f0537aa-0"
})(EventPageAboutSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.white;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageAboutSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageAboutSection__Container",
    componentId: "sc-1f0537aa-1"
})(EventPageAboutSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAboutSection__Description",
    componentId: "sc-1f0537aa-2"
})(EventPageAboutSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var TagsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAboutSection__TagsWrapper",
    componentId: "sc-1f0537aa-3"
})(EventPageAboutSection_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var TopicsHeading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventPageAboutSection__TopicsHeading",
    componentId: "sc-1f0537aa-4"
})(EventPageAboutSection_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var Tags = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAboutSection__Tags",
    componentId: "sc-1f0537aa-5"
})(EventPageAboutSection_templateObject5());
var Tag = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAboutSection__Tag",
    componentId: "sc-1f0537aa-6"
})(EventPageAboutSection_templateObject6());
var EventPageAboutSection = function() {
    var _ = (0,lib.useTranslate)()._;
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAboutSection_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeading, {
                    children: _("ABOUT")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: flatEvent.description
                        }),
                        flatEvent.tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagsWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicsHeading, {
                                    children: _("EVENT TOPICS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                    children: flatEvent.tags.map(function(param) {
                                        var name = param.name, id = param.id;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                            children: name
                                        }, id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHowToParticipate/index.tsx




function EventPageHowToParticipate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 27px 0 31px;\n  background: ",
        ";\n  color: ",
        ";\n  ",
        " {\n    padding: 32px 0 37px;\n  }\n"
    ]);
    EventPageHowToParticipate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageHowToParticipate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 900px;\n  ",
        " {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n"
    ]);
    EventPageHowToParticipate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageHowToParticipate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 26px;\n  ",
        " {\n    max-width: 280px;\n  }\n"
    ]);
    EventPageHowToParticipate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageHowToParticipate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 120%;\n  margin-bottom: 15px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  ",
        " {\n    font-weight: 600;\n    font-size: 18px;\n    margin-bottom: 22px;\n  }\n"
    ]);
    EventPageHowToParticipate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageHowToParticipate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 21px;\n  ",
        " {\n    font-size: 16px;\n    line-height: 24px;\n  }\n"
    ]);
    EventPageHowToParticipate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var EventPageHowToParticipate_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageHowToParticipate__Section",
    componentId: "sc-d6481241-0"
})(EventPageHowToParticipate_templateObject(), function(param) {
    var theme = param.theme, $background = param.$background;
    return $background !== null && $background !== void 0 ? $background : theme.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHowToParticipate_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageHowToParticipate__Container",
    componentId: "sc-d6481241-1"
})(EventPageHowToParticipate_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHowToParticipate_HeadingContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHowToParticipate__HeadingContainer",
    componentId: "sc-d6481241-2"
})(EventPageHowToParticipate_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHowToParticipate_Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventPageHowToParticipate__Heading",
    componentId: "sc-d6481241-3"
})(EventPageHowToParticipate_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHowToParticipate_Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventPageHowToParticipate__Description",
    componentId: "sc-d6481241-4"
})(EventPageHowToParticipate_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHowToParticipate = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var _ = (0,lib.useTranslate)()._;
    var ref = (0,react.useContext)(EventPageContext/* EventPageContext */.P), isUpcoming = ref.isUpcoming, event = ref.event;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    if (!isUpcoming || !flatEvent.howToParticipate) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHowToParticipate_Section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            $background: flatEvent.background
        }, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHowToParticipate_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHowToParticipate_HeadingContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHowToParticipate_Heading, {
                            children: _("How to participate")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHowToParticipate_Description, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                children: flatEvent.howToParticipate
                            })
                        })
                    ]
                })
            })
        }))
    });
};

// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/components/player/index.tsx + 30 modules
var player = __webpack_require__(44732);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageVideoPlayer/index.tsx

function EventPageVideoPlayer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      order: -1;\n    "
    ]);
    EventPageVideoPlayer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageVideoPlayer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        " {\n    .player__locked-content {\n      --base-unit: 100vw / 500;\n    }\n  }\n  ",
        "\n"
    ]);
    EventPageVideoPlayer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var EventPageVideoPlayer_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageVideoPlayer__Container",
    componentId: "sc-870c0dfd-0"
})(EventPageVideoPlayer_templateObject1(), (0,common.ar)(16 / 9, "max(20vw, calc(100vh - var(--header-static-height) - 130px))"), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, function(param) {
    var $first = param.$first;
    return $first && (0,styled_components_browser_esm.css)(EventPageVideoPlayer_templateObject());
});
var EventPageVideoPlayer = function() {
    var ref;
    var ref1 = (0,react.useContext)(EventPageContext/* EventPageContext */.P), event = ref1.event, isUpcoming = ref1.isUpcoming, isNow = ref1.isNow, isCompleted = ref1.isCompleted;
    var video = (ref = event.videos[0]) === null || ref === void 0 ? void 0 : ref.videos_id;
    if (!video || isUpcoming) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageVideoPlayer_Container, {
        $first: isNow || isCompleted,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(player/* NeauviaPlayerLayer */.jT, {
            video: video,
            autoPlay: true
        })
    });
};

// EXTERNAL MODULE: ./src/modules/home/components/HomeBusinessCasesSection/Showcase.tsx
var Showcase = __webpack_require__(45499);
// EXTERNAL MODULE: ./src/components/common/ModalPortal.tsx
var ModalPortal = __webpack_require__(89432);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/ScrollableContent.tsx
var ScrollableContent = __webpack_require__(53402);
// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageSpeakersSection/EventPageSpeakerModal.tsx

function EventPageSpeakerModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: calc(var(--scrollbar-padding) * -1);\n  right: 0;\n  bottom: 0;\n"
    ]);
    EventPageSpeakerModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  .simplebar-content-wrapper {\n    display: flex;\n    flex-direction: column;\n  }\n  .simplebar-content {\n    flex: 1;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1020px;\n  padding-top: 60px;\n  padding-bottom: 60px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  ",
        " {\n    padding-bottom: 30px;\n    gap: 20px;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: center;\n    height: calc(100% - 60px);\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    position: absolute;\n    right: 10vw;\n    top: 60px;\n    padding: 8px;\n    ",
        " {\n      top: 20px;\n      right: 20px;\n      svg {\n        width: 25px;\n        height: 25px;\n      }\n    }\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-width: 262px;\n  height: 420px;\n  background: ",
        ";\n  ",
        " {\n    min-width: 178px;\n    height: 286px;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n\n  ",
        " {\n    object-position: center center;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 23px;\n  ",
        " {\n    gap: 8px;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 21px;\n  line-height: 26px;\n  font-weight: 400;\n  color: ",
        ";\n  ",
        " {\n    font-size: 26px;\n    line-height: 30px;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function EventPageSpeakerModal_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 300;\n  color: ",
        ";\n  ",
        " {\n    font-size: 16px;\n    line-height: 24px;\n  }\n"
    ]);
    EventPageSpeakerModal_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}










var EventPageSpeakerModal_Container = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "EventPageSpeakerModal__Container",
    componentId: "sc-ef59c041-0"
})(EventPageSpeakerModal_templateObject());
var StyledScrollableContent = (0,styled_components_browser_esm["default"])(ScrollableContent/* ScrollableContent */.t).withConfig({
    displayName: "EventPageSpeakerModal__StyledScrollableContent",
    componentId: "sc-ef59c041-1"
})(EventPageSpeakerModal_templateObject1());
var ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageSpeakerModal__ContentContainer",
    componentId: "sc-ef59c041-2"
})(EventPageSpeakerModal_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var CloseModalButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "EventPageSpeakerModal__CloseModalButton",
    componentId: "sc-ef59c041-3"
})(EventPageSpeakerModal_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var SpeakerImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageSpeakerModal__SpeakerImageWrapper",
    componentId: "sc-ef59c041-4"
})(EventPageSpeakerModal_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var SpeakerImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "EventPageSpeakerModal__SpeakerImage",
    componentId: "sc-ef59c041-5"
})(EventPageSpeakerModal_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageSpeakerModal_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageSpeakerModal__Content",
    componentId: "sc-ef59c041-6"
})(EventPageSpeakerModal_templateObject6(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageSpeakerModal_Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventPageSpeakerModal__Heading",
    componentId: "sc-ef59c041-7"
})(EventPageSpeakerModal_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageSpeakerModal_Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventPageSpeakerModal__Description",
    componentId: "sc-ef59c041-8"
})(EventPageSpeakerModal_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageSpeakerModal = function(param) {
    var speaker = param.speaker, close = param.close;
    var translatedSpeaker = (0,useTranslateItem/* useTranslateItem */.L)(speaker);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakerModal_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledScrollableContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseModalButton, {
                    kind: "text",
                    icon: Close/* Close */.x,
                    iconProps: {
                        size: 32,
                        enabled: true
                    },
                    onClick: close
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerImageWrapper, {
                            children: translatedSpeaker.portrait && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerImage, {
                                as: DirectusImage/* DirectusImage */.q,
                                src: translatedSpeaker.portrait.id,
                                layout: "fill"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageSpeakerModal_Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakerModal_Heading, {
                                    children: translatedSpeaker.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakerModal_Description, {
                                    children: translatedSpeaker.description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageSpeakersSection/index.tsx

function EventPageSpeakersSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 41px 0 20px;\n  ",
        " {\n    padding: 64px 0 30px;\n  }\n"
    ]);
    EventPageSpeakersSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageSpeakersSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1020px;\n"
    ]);
    EventPageSpeakersSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageSpeakersSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 15px;\n  grid-template-columns: repeat(2, 1fr);\n  max-width: 1170px;\n  padding-top: 30px;\n  ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n    padding-top: 40px;\n  }\n  ",
        " {\n    padding-left: 0;\n    padding-right: 0;\n  }\n"
    ]);
    EventPageSpeakersSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageSpeakersSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &&& {\n    height: 286px;\n    margin: 0;\n    cursor: pointer;\n    & > div {\n      width: 100%;\n    }\n    ",
        " {\n      height: 420px;\n      &:nth-child(4n - 1) {\n        top: -60px;\n      }\n      &:nth-child(4n - 2) {\n        top: 60px;\n      }\n      &:nth-child(4n) {\n        top: 40px;\n      }\n      padding-bottom: 30px;\n      h4 + div {\n        line-height: 20px;\n      }\n    }\n    ",
        " {\n      &:nth-child(2n) {\n        top: 20px;\n      }\n      h4 {\n        font-size: 18px;\n        line-height: 21px;\n      }\n      h4 + div {\n        font-size: 12px;\n        line-height: 16px;\n        margin-top: 4px;\n      }\n    }\n  }\n"
    ]);
    EventPageSpeakersSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var EventPageSpeakersSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageSpeakersSection__Section",
    componentId: "sc-a0e6a28c-0"
})(EventPageSpeakersSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageSpeakersSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageSpeakersSection__Container",
    componentId: "sc-a0e6a28c-1"
})(EventPageSpeakersSection_templateObject1());
var SpeakersContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageSpeakersSection__SpeakersContainer",
    componentId: "sc-a0e6a28c-2"
})(EventPageSpeakersSection_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var SpeakerShowcase = (0,styled_components_browser_esm["default"])(Showcase/* Showcase */.$m).attrs({
    forwardedAs: "div"
}).withConfig({
    displayName: "EventPageSpeakersSection__SpeakerShowcase",
    componentId: "sc-a0e6a28c-3"
})(EventPageSpeakersSection_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageSpeakersSection = function() {
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var ref = (0,react.useState)(null), activeSpeaker = ref[0], setActiveSpeaker = ref[1];
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var _ = (0,lib.useTranslate)()._;
    var preparedSpeakers = (0,react.useMemo)(function() {
        return event.speakers.map(function(speaker) {
            return translateItem(speaker.people_id);
        }) || [];
    }, [
        event,
        translateItem
    ]);
    if (preparedSpeakers.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageSpeakersSection_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakersSection_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeading, {
                    children: _("speakers")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakersContainer, {
                children: preparedSpeakers.map(function(speaker, i) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(SpeakerShowcase, {
                        image: (ref = speaker.portrait) === null || ref === void 0 ? void 0 : ref.id,
                        title: speaker.name,
                        subtitle: [
                            speaker.degree,
                            speaker.title
                        ].filter(function(el) {
                            return el;
                        }).join(", "),
                        onClick: function() {
                            return setActiveSpeaker(speaker);
                        },
                        withChevron: true
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPortal/* ModalPortal */.H, {
                open: !!activeSpeaker,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                    exitBeforeEnter: true,
                    children: activeSpeaker && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakerModal, {
                        speaker: activeSpeaker,
                        close: function() {
                            return setActiveSpeaker(null);
                        }
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/modules/events/hooks/useEventRelatedVideosListQuery.ts
var useEventRelatedVideosListQuery = __webpack_require__(98310);
// EXTERNAL MODULE: ./src/modules/materials/components/ShowcasePage/renderers/SliderSectionRender.tsx
var SliderSectionRender = __webpack_require__(86649);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageRelatedVideosSection/index.tsx

function EventPageRelatedVideosSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 41px 0 20px;\n  ",
        " {\n    padding: 64px 0 30px;\n  }\n"
    ]);
    EventPageRelatedVideosSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageRelatedVideosSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1020px;\n"
    ]);
    EventPageRelatedVideosSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageRelatedVideosSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0 0;\n"
    ]);
    EventPageRelatedVideosSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageRelatedVideosSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0 0;\n"
    ]);
    EventPageRelatedVideosSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var EventPageRelatedVideosSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageRelatedVideosSection__Section",
    componentId: "sc-e17c25fb-0"
})(EventPageRelatedVideosSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageRelatedVideosSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageRelatedVideosSection__Container",
    componentId: "sc-e17c25fb-1"
})(EventPageRelatedVideosSection_templateObject1());
var VideosContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageRelatedVideosSection__VideosContainer",
    componentId: "sc-e17c25fb-2"
})(EventPageRelatedVideosSection_templateObject2());
var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageRelatedVideosSection__ButtonContainer",
    componentId: "sc-e17c25fb-3"
})(EventPageRelatedVideosSection_templateObject3());
var EventPageRelatedVideosSection = function() {
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var _ = (0,lib.useTranslate)()._;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var videos = (0,useEventRelatedVideosListQuery/* useEventRelatedVideosListQuery */.w)({
        event: event,
        limit: 10
    });
    if (!videos.data || videos.data.length <= 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageRelatedVideosSection_Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageRelatedVideosSection_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeading, {
                    children: _("WATCH HIGHLIGHTS FROM THE EVENT")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideosContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderSectionRender/* SliderSectionRender */.t, {
                        section: {
                            name: flatEvent.name
                        },
                        event: event,
                        items: videos.data,
                        header: false
                    })
                }),
                videos.data.length >= 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: {
                            pathname: route/* route.event */.BC.event(event).episodes()
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            forwardedAs: "a",
                            icon: ChevronRight/* ChevronRight */._,
                            iconProps: {
                                position: "right"
                            },
                            children: _("See all")
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/ScrollToViewport.tsx
var ScrollToViewport = __webpack_require__(66660);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/components/icons/ChevronBottom.tsx
var ChevronBottom = __webpack_require__(56647);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/components/common/ExpandTransition.tsx
var ExpandTransition = __webpack_require__(70172);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageFAQSection/EventPageFAQItem.tsx

function EventPageFAQItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  color: ",
        ";\n"
    ]);
    EventPageFAQItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageFAQItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 21px;\n  line-height: 26px;\n  margin-right: 20px;\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    EventPageFAQItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageFAQItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        transform: rotate(180deg);\n      "
    ]);
    EventPageFAQItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageFAQItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 0;\n  cursor: pointer;\n  border-bottom: 1px solid\n    ",
        ";\n  svg {\n    min-width: 13px;\n    ",
        "\n  }\n  ",
        " {\n    padding: 18px 0;\n  }\n"
    ]);
    EventPageFAQItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageFAQItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid\n    ",
        ";\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n  padding: 20px 0 30px;\n  b,\n  strong {\n    font-weight: 700;\n  }\n  ",
        " {\n    font-size: 14px;\n    line-height: 21px;\n  }\n"
    ]);
    EventPageFAQItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








var EventPageFAQItem_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageFAQItem__Container",
    componentId: "sc-bdb2d239-0"
})(EventPageFAQItem_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var EventPageFAQItem_Heading = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "EventPageFAQItem__Heading",
    componentId: "sc-bdb2d239-1"
})(EventPageFAQItem_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageFAQItem_Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "EventPageFAQItem__Header",
    componentId: "sc-bdb2d239-2"
})(EventPageFAQItem_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.7, theme.palette.white);
}, function(param) {
    var $active = param.$active;
    return $active && (0,styled_components_browser_esm.css)(EventPageFAQItem_templateObject2());
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageFAQItem_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageFAQItem__Description",
    componentId: "sc-bdb2d239-3"
})(EventPageFAQItem_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.7, theme.palette.white);
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageFAQItem = function(param) {
    var label = param.label, answer = param.answer, isExpanded = param.isExpanded, toggleIsExpanded = param.toggleIsExpanded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageFAQItem_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageFAQItem_Header, {
                $active: isExpanded,
                onClick: toggleIsExpanded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQItem_Heading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronBottom/* ChevronBottom */.B, {
                        size: 13
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandTransition/* ExpandTransition */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQItem_Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: answer
                        })
                    })
                }, "content")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageFAQSection/index.tsx

function EventPageFAQSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin-top: 40px;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: calc(100% + var(--footer-static-height));\n    background: linear-gradient(263.5deg, #a2002a 35.42%, #cd0338 92.44%),\n      linear-gradient(259.64deg, #a2002a -68.45%, #cd0338 95.71%);\n  }\n  ",
        " {\n    margin-top: 70px;\n  }\n"
    ]);
    EventPageFAQSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageFAQSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 30px 0 34px;\n  ",
        " {\n    padding: 54px 0 76px;\n  }\n"
    ]);
    EventPageFAQSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageFAQSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 1020px;\n  z-index: 1;\n"
    ]);
    EventPageFAQSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageFAQSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 660px;\n  padding: 0 !important;\n  margin-top: 40px;\n"
    ]);
    EventPageFAQSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageFAQSection_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n  background: transparent;\n  ",
        " {\n    & > div {\n      position: relative;\n      max-width: 940px;\n      &:before {\n        content: '';\n        background-color: currentColor;\n        position: absolute;\n        top: 4px;\n        bottom: 0;\n        height: 83px;\n        left: 0;\n        width: 19px;\n        clip-path: polygon(0 0, 40% 0, 100% 100%, 90% 100%);\n      }\n    }\n  }\n"
    ]);
    EventPageFAQSection_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
















var Background = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageFAQSection__Background",
    componentId: "sc-824077b8-0"
})(EventPageFAQSection_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageFAQSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageFAQSection__Section",
    componentId: "sc-824077b8-1"
})(EventPageFAQSection_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageFAQSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageFAQSection__Container",
    componentId: "sc-824077b8-2"
})(EventPageFAQSection_templateObject2());
var EventPageFAQSection_ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageFAQSection__ContentContainer",
    componentId: "sc-824077b8-3"
})(EventPageFAQSection_templateObject3());
var HowToParticipateSection = (0,styled_components_browser_esm["default"])(EventPageHowToParticipate).withConfig({
    displayName: "EventPageFAQSection__HowToParticipateSection",
    componentId: "sc-824077b8-4"
})(EventPageFAQSection_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageFAQSection = function() {
    var ref;
    var ref1 = (0,react.useState)(null), expandedItem = ref1[0], setExpandedItem = ref1[1];
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var _ = (0,lib.useTranslate)()._;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    if (((ref = event.faq) === null || ref === void 0 ? void 0 : ref.length) === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQSection_Section, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageFAQSection_Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeading, {
                                children: _("faq")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQSection_ContentContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                    initial: false,
                                    children: event.faq.map(function(item) {
                                        return translateItem(item.eventFaq_id);
                                    }).filter(function(param) {
                                        var question = param.question, answer = param.answer;
                                        return question && answer;
                                    }).map(function(param) {
                                        var question = param.question, answer = param.answer;
                                        var isExpanded = question === expandedItem;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToViewport/* ScrollToViewport */.v, {
                                            active: isExpanded,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandTransition/* ExpandTransition */.n, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQItem, {
                                                    label: question,
                                                    answer: answer,
                                                    isExpanded: isExpanded,
                                                    toggleIsExpanded: function() {
                                                        return isExpanded ? setExpandedItem(null) : setExpandedItem(question);
                                                    }
                                                })
                                            })
                                        }, question);
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToParticipateSection, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/ScrollToSectionOnClick.tsx
var ScrollToSectionOnClick = __webpack_require__(16001);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaHeader.tsx

function EventPageAgendaHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n  color: ",
        ";\n  text-transform: none;\n  letter-spacing: 0;\n  margin-bottom: 40px;\n\n  ",
        " {\n    font-size: 14px;\n    line-height: 21px;\n    margin-bottom: 26px;\n  }\n"
    ]);
    EventPageAgendaHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 855px;\n  padding: 0 !important;\n"
    ]);
    EventPageAgendaHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAgendaHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 25px;\n  width: 100%;\n"
    ]);
    EventPageAgendaHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageAgendaHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        " !important;\n    "
    ]);
    EventPageAgendaHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageAgendaHeader_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    EventPageAgendaHeader_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var EventPageAgendaHeader_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaHeader__Description",
    componentId: "sc-3d5d5223-0"
})(EventPageAgendaHeader_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageAgendaHeader_ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageAgendaHeader__ContentContainer",
    componentId: "sc-3d5d5223-1"
})(EventPageAgendaHeader_templateObject1());
var ButtonsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaHeader__ButtonsContainer",
    componentId: "sc-3d5d5223-2"
})(EventPageAgendaHeader_templateObject2());
var NavButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "EventPageAgendaHeader__NavButton",
    componentId: "sc-3d5d5223-3"
})(EventPageAgendaHeader_templateObject4(), (0,casePathEmptyString/* casePathEmptyString */.Q)("$active")((0,styled_components_browser_esm.css)(EventPageAgendaHeader_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
})));
var EventPageAgendaHeader = function(param) {
    var schedule = param.schedule, agenda = param.agenda;
    var _ = (0,lib.useTranslate)()._;
    var translatedAgenda = (0,useTranslateItem/* useTranslateItem */.L)(agenda);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeading, {
                children: _("agenda")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaHeader_ContentContainer, {
                children: [
                    translatedAgenda.agendaDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaHeader_Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: translatedAgenda.agendaDescription
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonsContainer, {
                        children: schedule.map(function(day) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToSectionOnClick/* ScrollToSectionOnClick */.d, {
                                id: day.id,
                                offset: 30,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavButton, {
                                    kind: "text",
                                    children: day.label
                                })
                            }, day.label);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./src/components/common/DispatchOnClick.tsx
var DispatchOnClick = __webpack_require__(94565);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageSignupPopup.tsx



function EventPageSignupPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: 90;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  ",
        " {\n    left: calc(50% - (var(--scrollbar-padding) / 2));\n    transform: translateX(-50%);\n    width: 750px;\n    max-width: 100%;\n    bottom: 10vh;\n    right: unset;\n  }\n"
    ]);
    EventPageSignupPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageSignupPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: #333333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  box-shadow: 0 13px 9px 0 rgba(0, 0, 0, 0.35);\n  color: white;\n  gap: 16px;\n\n  ",
        " {\n    box-shadow: 0 -13px 9px 0 rgba(0, 0, 0, 0.35);\n\n    padding: 20rpx;\n    height: 110px;\n\n    .btn {\n      min-width: 0;\n      flex: 1 1 auto;\n    }\n  }\n"
    ]);
    EventPageSignupPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageSignupPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  text-align: left;\n  word-break: keep-all;\n  white-space: nowrap;\n\n  ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    EventPageSignupPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var EventPagePopupContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageSignupPopup__EventPagePopupContainer",
    componentId: "sc-4a2c58ee-0"
})(EventPageSignupPopup_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPagePopup = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "EventPageSignupPopup__EventPagePopup",
    componentId: "sc-4a2c58ee-1"
})(EventPageSignupPopup_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPagePopupText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageSignupPopup__EventPagePopupText",
    componentId: "sc-4a2c58ee-2"
})(EventPageSignupPopup_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageSignupPopup = function(param) {
    var onComplete = param.onComplete, timeslotIds = param.timeslotIds;
    var ref = (0,lib.useTranslate)(), _n = ref._n, _ = ref._;
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPagePopupContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPagePopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            from: "bottom"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPagePopupText, {
                    children: _n("Joining {sessions} session", "Joining {sessions} sessions", timeslotIds.length, undefined, {
                        sessions: timeslotIds.length
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchOnClick/* DispatchOnClick */.Q, {
                    type: "modalOpen",
                    payload: {
                        kind: "eventSignup",
                        timeslotIds: timeslotIds,
                        eventId: event.id,
                        onComplete: onComplete
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        variant: "inverted",
                        children: _("Sign up")
                    })
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./src/modules/user/components/Avatar.tsx + 2 modules
var Avatar = __webpack_require__(43029);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotSpeakers.tsx

function EventPageAgendaTimeslotSpeakers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 10px 20px;\n  max-width: max-content;\n\n  margin-top: 12px;\n\n  ",
        " {\n    grid-template-columns: repeat(2, min-content);\n  }\n"
    ]);
    EventPageAgendaTimeslotSpeakers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotSpeakers_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    EventPageAgendaTimeslotSpeakers_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotSpeakers_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  min-width: 40px;\n"
    ]);
    EventPageAgendaTimeslotSpeakers_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotSpeakers_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 18px;\n  color: ",
        ";\n  margin: 0 0 0 8px;\n  ",
        " {\n    margin: 0 8px 0 0;\n  }\n"
    ]);
    EventPageAgendaTimeslotSpeakers_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var EventPageAgendaTimeslotSpeakers_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotSpeakers__Container",
    componentId: "sc-c0dc1bbe-0"
})(EventPageAgendaTimeslotSpeakers_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var SpeakerItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotSpeakers__SpeakerItem",
    componentId: "sc-c0dc1bbe-1"
})(EventPageAgendaTimeslotSpeakers_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledAvatar = (0,styled_components_browser_esm["default"])(Avatar/* Avatar */.qE).withConfig({
    displayName: "EventPageAgendaTimeslotSpeakers__StyledAvatar",
    componentId: "sc-c0dc1bbe-2"
})(EventPageAgendaTimeslotSpeakers_templateObject2());
var Name = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventPageAgendaTimeslotSpeakers__Name",
    componentId: "sc-c0dc1bbe-3"
})(EventPageAgendaTimeslotSpeakers_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
}, theme/* dirRTL */.gX);
var EventPageAgendaTimeslotSpeakers = function(param) {
    var speakers = param.speakers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotSpeakers_Container, {
        children: speakers.map(function(speaker) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(SpeakerItem, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAvatar, {
                        src: (ref = speaker.people_id.avatar) === null || ref === void 0 ? void 0 : ref.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                        children: speaker.people_id.name
                    })
                ]
            }, speaker.people_id.name);
        })
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDate.tsx

function EventPageAgendaTimeslotDate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 130px;\n  margin-right: 20px;\n"
    ]);
    EventPageAgendaTimeslotDate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  letter-spacing: 0.08em;\n  font-size: 18px;\n  line-height: 21px;\n  font-weight: 300;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 14px;\n    line-height: 21px;\n    color: ",
        ";\n  }\n"
    ]);
    EventPageAgendaTimeslotDate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var EventPageAgendaTimeslotDate_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDate__Container",
    componentId: "sc-ac1356ef-0"
})(EventPageAgendaTimeslotDate_templateObject());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPageAgendaTimeslotDate__Text",
    componentId: "sc-ac1356ef-1"
})(EventPageAgendaTimeslotDate_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
});
var EventPageAgendaTimeslotDate = function(param) {
    var startDate = param.startDate, endDate = param.endDate;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDate_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                    children: startDate
                }),
                "\xa0-\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                    children: endDate
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/ExpandableContent/ExpandButton.tsx
var ExpandButton = __webpack_require__(20516);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDescription.tsx

function EventPageAgendaTimeslotDescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 300;\n  color: ",
        ";\n  margin-bottom: -24px;\n  span {\n    display: block;\n    padding-bottom: 20px;\n  }\n  ",
        " {\n    margin-bottom: -14px;\n    font-size: 14px;\n    line-height: 21px;\n  }\n"
    ]);
    EventPageAgendaTimeslotDescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDescription_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    padding: 6px;\n    margin-right: -20px;\n    margin-top: -20px;\n    ",
        " {\n      margin-right: 0;\n      margin-left: -20px;\n    }\n    & > p {\n      display: none;\n    }\n  }\n"
    ]);
    EventPageAgendaTimeslotDescription_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDescription_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    EventPageAgendaTimeslotDescription_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var EventPageAgendaTimeslotDescription_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDescription__Container",
    componentId: "sc-8db39bcc-0"
})(EventPageAgendaTimeslotDescription_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var StyledExpandButton = (0,styled_components_browser_esm["default"])(ExpandButton/* ExpandButton */.V).withConfig({
    displayName: "EventPageAgendaTimeslotDescription__StyledExpandButton",
    componentId: "sc-8db39bcc-1"
})(EventPageAgendaTimeslotDescription_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX);
var EventPageAgendaTimeslotDescription_Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDescription__Description",
    componentId: "sc-8db39bcc-2"
})(EventPageAgendaTimeslotDescription_templateObject2());
var EventPageAgendaTimeslotDescription = function(param) {
    var description = param.description, isExpanded = param.isExpanded, toggleIsExpanded = param.toggleIsExpanded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaTimeslotDescription_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExpandButton, {
                active: isExpanded,
                onClick: toggleIsExpanded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandTransition/* ExpandTransition */.n, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDescription_Description, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: description
                        })
                    })
                }, "content")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/Popup/index.tsx
var Popup = __webpack_require__(76088);
// EXTERNAL MODULE: ./node_modules/qrcode/lib/browser.js
var browser = __webpack_require__(92592);
;// CONCATENATED MODULE: ./src/components/common/QRCode.tsx





var QRCode = function(_param) {
    var value = _param.value, _margin = _param.margin, margin = _margin === void 0 ? 0 : _margin, _width = _param.width, width = _width === void 0 ? 250 : _width, style = _param.style, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "margin",
        "width",
        "style",
        "className"
    ]);
    var canvasRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        browser.toCanvas(canvasRef.current, value, (0,_object_spread/* default */.Z)({
            margin: margin,
            width: width
        }, props));
    }, [
        value,
        margin,
        width,
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
        ref: canvasRef,
        style: style,
        className: className
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageTicketPopup.tsx




function EventPageTicketPopup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: auto;\n"
    ]);
    EventPageTicketPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageTicketPopup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n"
    ]);
    EventPageTicketPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageTicketPopup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 32px 0 24px;\n"
    ]);
    EventPageTicketPopup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledPopup = (0,styled_components_browser_esm["default"])(Popup/* Popup */.G).withConfig({
    displayName: "EventPageTicketPopup__StyledPopup",
    componentId: "sc-a28b4954-0"
})(EventPageTicketPopup_templateObject());
var Title = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "EventPageTicketPopup__Title",
    componentId: "sc-a28b4954-1"
})(EventPageTicketPopup_templateObject1());
var StyledQRCode = (0,styled_components_browser_esm["default"])(QRCode).withConfig({
    displayName: "EventPageTicketPopup__StyledQRCode",
    componentId: "sc-a28b4954-2"
})(EventPageTicketPopup_templateObject2());
var EventPageTicketPopup = function(_param) {
    var ticket = _param.ticket, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ticket"
    ]);
    var _ = (0,lib.useTranslate)()._;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "secondary",
        queryParam: "ticket",
        enterDelay: router.query.ticket ? 300 : 0
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: _("Ticket")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQRCode, {
                value: ticket
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/common/Checkbox.tsx
var Checkbox = __webpack_require__(74003);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isPast/index.js
var isPast = __webpack_require__(33913);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/EventPageAgendaTimeslotDetails.tsx

function EventPageAgendaTimeslotDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto min-content;\n  gap: 20px;\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  min-width: min-content;\n\n  .btn {\n    min-width: 0;\n  }\n\n  ",
        " {\n    margin-right: -20px;\n  }\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 24px;\n  overflow-wrap: break-word;\n  text-transform: uppercase;\n\n  ",
        " {\n    font-size: 14px;\n    line-height: 19px;\n  }\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 600;\n          color: ",
        ";\n        "
    ]);
    EventPageAgendaTimeslotDetails_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          font-weight: 600;\n          color: ",
        ";\n        "
    ]);
    EventPageAgendaTimeslotDetails_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslotDetails_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: ",
        ";\n\n  &:not(:last-child):after {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    height: 4px;\n    vertical-align: middle;\n    line-height: 20px;\n    border-radius: 50%;\n    background: ",
        ";\n    margin: 0 8px;\n  }\n\n  ",
        "\n"
    ]);
    EventPageAgendaTimeslotDetails_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var EventPageAgendaTimeslotDetails_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__Container",
    componentId: "sc-ca028f21-0"
})(EventPageAgendaTimeslotDetails_templateObject());
var EventPageAgendaTimeslotDetails_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__Header",
    componentId: "sc-ca028f21-1"
})(EventPageAgendaTimeslotDetails_templateObject1());
var Action = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__Action",
    componentId: "sc-ca028f21-2"
})(EventPageAgendaTimeslotDetails_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageAgendaTimeslotDetails_Heading = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__Heading",
    componentId: "sc-ca028f21-3"
})(EventPageAgendaTimeslotDetails_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var DetailsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__DetailsContainer",
    componentId: "sc-ca028f21-4"
})(EventPageAgendaTimeslotDetails_templateObject4());
var Detail = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPageAgendaTimeslotDetails__Detail",
    componentId: "sc-ca028f21-5"
})(EventPageAgendaTimeslotDetails_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, function(param) {
    var $variant = param.$variant;
    switch($variant){
        case "primary":
            return (0,styled_components_browser_esm.css)(EventPageAgendaTimeslotDetails_templateObject5(), function(param) {
                var theme = param.theme;
                return theme.palette.success;
            });
        case "secondary":
            return (0,styled_components_browser_esm.css)(EventPageAgendaTimeslotDetails_templateObject6(), function(param) {
                var theme = param.theme;
                return theme.text.palette.accent;
            });
    }
});
var EventPageAgendaTimeslotDetails = function(param) {
    var timeslot = param.timeslot, toggleIsChecked = param.toggleIsChecked, isChecked = param.isChecked;
    var ref = (0,react.useState)(false), popupVisible = ref[0], setPopupVisible = ref[1];
    var isInPast = (0,isPast/* default */.Z)(new Date(timeslot.startDate));
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaTimeslotDetails_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaTimeslotDetails_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDetails_Heading, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: timeslot.title
                        })
                    }),
                    timeslot.ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            onClick: function() {
                                return setPopupVisible(true);
                            },
                            children: _("Show ticket")
                        })
                    }),
                    !timeslot.ticket && !isInPast && timeslot.requireRegistration && timeslot.availableSeats > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
                            checked: isChecked,
                            onClick: toggleIsChecked,
                            variant: "hero"
                        })
                    })
                ]
            }),
            timeslot.ticket && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageTicketPopup, {
                visible: popupVisible,
                ticket: timeslot.ticket,
                close: function() {
                    return setPopupVisible(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsContainer, {
                children: [
                    timeslot.requireRegistration && (timeslot.availableSeats > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail, {
                        $variant: "primary",
                        children: [
                            _("SEATS AVAILABLE"),
                            ": ",
                            timeslot.availableSeats
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                        $variant: "secondary",
                        children: _("FULL")
                    })),
                    timeslot.location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                        children: timeslot.location
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot/index.tsx

function EventPageAgendaTimeslot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n\n  padding: 32px 0;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        " {\n    flex-direction: column;\n\n    padding: 16px 0;\n  }\n"
    ]);
    EventPageAgendaTimeslot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaTimeslot_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  ",
        " {\n    padding-right: 20px;\n  }\n"
    ]);
    EventPageAgendaTimeslot_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var EventPageAgendaTimeslot_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslot__Container",
    componentId: "sc-40f3c0a0-0"
})(EventPageAgendaTimeslot_templateObject(), function(param) {
    var theme = param.theme;
    return theme.skeleton.base;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ContentColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaTimeslot__ContentColumn",
    componentId: "sc-40f3c0a0-1"
})(EventPageAgendaTimeslot_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageAgendaTimeslot = function(param) {
    var timeslot = param.timeslot, isExpanded = param.isExpanded, toggleIsExpanded = param.toggleIsExpanded, isChecked = param.isChecked, toggleIsChecked = param.toggleIsChecked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaTimeslot_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDate, {
                startDate: timeslot.startDate,
                endDate: timeslot.endDate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentColumn, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDetails, {
                        timeslot: timeslot,
                        isChecked: isChecked,
                        toggleIsChecked: toggleIsChecked
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotSpeakers, {
                        speakers: timeslot.speakers
                    }),
                    timeslot.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslotDescription, {
                        description: timeslot.description,
                        isExpanded: isExpanded,
                        toggleIsExpanded: toggleIsExpanded
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaScheduleDay.tsx

function EventPageAgendaScheduleDay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 30px;\n"
    ]);
    EventPageAgendaScheduleDay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaScheduleDay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 20px;\n  align-items: baseline;\n\n  h2 {\n    margin: 0;\n    padding: 0;\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n  h3 {\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 16.8px;\n  }\n"
    ]);
    EventPageAgendaScheduleDay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var EventPageAgendaScheduleDay_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageAgendaScheduleDay__Section",
    componentId: "sc-3c1b3546-0"
})(EventPageAgendaScheduleDay_templateObject());
var DatesRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageAgendaScheduleDay__DatesRow",
    componentId: "sc-3c1b3546-1"
})(EventPageAgendaScheduleDay_templateObject1());
var EventPageAgendaScheduleDay = function(param) {
    var scheduleDay = param.scheduleDay, expandedTimeslots = param.expandedTimeslots, selectedTimeslots = param.selectedTimeslots, setExpandedTimeslots = param.setExpandedTimeslots, setSelectedTimeslots = param.setSelectedTimeslots;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaScheduleDay_Section, {
        id: scheduleDay.id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatesRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: scheduleDay.longLabel.toLocaleUpperCase()
                })
            }),
            scheduleDay.timeslots.map(function(timeslot) {
                var isExpanded = expandedTimeslots.includes(timeslot.id);
                var isChecked = selectedTimeslots.includes(timeslot.id);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToViewport/* ScrollToViewport */.v, {
                    active: isExpanded,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandTransition/* ExpandTransition */.n, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaTimeslot, {
                            timeslot: timeslot,
                            isChecked: isChecked,
                            toggleIsChecked: function() {
                                if (isChecked) {
                                    setSelectedTimeslots(function(prev) {
                                        return prev.filter(function(id) {
                                            return id !== timeslot.id;
                                        });
                                    });
                                } else {
                                    setSelectedTimeslots(function(prev) {
                                        return prev.concat(timeslot.id);
                                    });
                                }
                            },
                            isExpanded: isExpanded,
                            toggleIsExpanded: function() {
                                return isExpanded ? setExpandedTimeslots(function(prev) {
                                    return prev.filter(function(id) {
                                        return id !== timeslot.id;
                                    });
                                }) : setExpandedTimeslots(function(prev) {
                                    return prev.concat(timeslot.id);
                                });
                            }
                        })
                    })
                }, timeslot.id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/modules/events/hooks/useEventTicketQuery.ts
var useEventTicketQuery = __webpack_require__(95224);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaSchedule.tsx







var EventPageAgendaSchedule = function(param) {
    var schedule = param.schedule;
    var ref = (0,react.useState)([]), expandedTimeslots = ref[0], setExpandedTimeslots = ref[1];
    var ref1 = (0,react.useState)([]), selectedTimeslots = ref1[0], setSelectedTimeslots = ref1[1];
    var popupVisible = selectedTimeslots.length > 0;
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var ref2 = (0,useEventTicketQuery/* useEventTicketQuery */.I)(event.id), tickets = ref2.data;
    (0,react.useEffect)(function() {
        /*
      Remove selected timeslots that are already present in ticket. This is possible in scenario when user
      selects timeslots as guest and later logs in and has already signed up for some of them previously.
     */ setSelectedTimeslots(function(current) {
            return current.filter(function(a) {
                return !(tickets === null || tickets === void 0 ? void 0 : tickets.timeslots.includes(a));
            });
        });
    }, [
        tickets
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: popupVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSignupPopup, {
                    timeslotIds: selectedTimeslots,
                    onComplete: function() {
                        return setSelectedTimeslots([]);
                    }
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                children: schedule.map(function(scheduleDay, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaScheduleDay, {
                        scheduleDay: scheduleDay,
                        day: i + 1,
                        expandedTimeslots: expandedTimeslots,
                        setExpandedTimeslots: setExpandedTimeslots,
                        selectedTimeslots: selectedTimeslots,
                        setSelectedTimeslots: setSelectedTimeslots
                    }, scheduleDay.longLabel);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 26 modules
var format = __webpack_require__(74461);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventAgendaSchedule.ts





var mapSubEventTimeslotToAgendaTimeslot = function(timeslot, subEvent, ticket) {
    var ref, ref1, ref2;
    if (!timeslot || !timeslot.startDate || !timeslot.endDate) {
        return null;
    }
    var _guestLimit;
    var participantsLimit = (_guestLimit = subEvent.guestLimit) !== null && _guestLimit !== void 0 ? _guestLimit : 0;
    var ref3;
    var participants = (ref3 = (ref = timeslot.eventParticipants_func) === null || ref === void 0 ? void 0 : ref.count) !== null && ref3 !== void 0 ? ref3 : 0;
    var ref4;
    return {
        id: timeslot.id,
        availableSeats: (0,rambda_esm.max)(0, participantsLimit - participants),
        participants: participants,
        participantsLimit: participantsLimit,
        requireRegistration: !!subEvent.requireRegistration,
        speakers: subEvent.speakers,
        startDate: timeslot.startDate,
        endDate: timeslot.endDate,
        logo: (ref1 = subEvent.event) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.id,
        title: subEvent.title,
        description: subEvent.description,
        location: subEvent.location,
        ticket: ((ref4 = ticket === null || ticket === void 0 ? void 0 : ticket.timeslots) !== null && ref4 !== void 0 ? ref4 : []).includes(timeslot.id) ? ticket === null || ticket === void 0 ? void 0 : ticket.ticket : undefined
    };
};
var useEventAgendaSchedule = function(agenda, eventId) {
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useEventTicketQuery/* useEventTicketQuery */.I)(eventId), ticket = ref.data;
    return (0,react.useMemo)(function() {
        var ref;
        var ref1;
        var timeslots = (ref1 = agenda === null || agenda === void 0 ? void 0 : (ref = agenda.subEvents) === null || ref === void 0 ? void 0 : ref.flatMap(function(subEvent) {
            var ref;
            return subEvent === null || subEvent === void 0 ? void 0 : (ref = subEvent.eventTimeslots) === null || ref === void 0 ? void 0 : ref.map(function(timeslot) {
                return mapSubEventTimeslotToAgendaTimeslot(timeslot, translateFn(subEvent), ticket);
            });
        }).filter(function(m) {
            return !!m;
        })) !== null && ref1 !== void 0 ? ref1 : [];
        var groupedTimeslotsByDay = (0,rambda_esm.groupBy)(function(m) {
            return (0,format/* default */.Z)((0,parseISO/* default */.Z)(m.startDate), "MMMM do");
        }, timeslots);
        return (0,rambda_esm.sortBy)(function(d) {
            return (0,parseISO/* default */.Z)(d.timeslots[0].startDate);
        }, Object.keys(groupedTimeslotsByDay).map(function(date) {
            return {
                id: "day-".concat((0,format/* default */.Z)((0,parseISO/* default */.Z)(groupedTimeslotsByDay[date][0].startDate), "dd-MM-yyyy")),
                label: date,
                longLabel: (0,format/* default */.Z)((0,parseISO/* default */.Z)(groupedTimeslotsByDay[date][0].startDate), "EEEE, d.LL.yyyy"),
                timeslots: (0,rambda_esm.sortBy)(function(m) {
                    return (0,parseISO/* default */.Z)(m.startDate);
                }, groupedTimeslotsByDay[date])
            };
        }));
    }, [
        agenda,
        ticket,
        translateFn
    ]);
};

// EXTERNAL MODULE: ./src/utils/reactQuery.tsx
var reactQuery = __webpack_require__(4766);
// EXTERNAL MODULE: ./src/modules/events/hooks/useEventAgendaQuery.ts + 1 modules
var useEventAgendaQuery = __webpack_require__(72447);
// EXTERNAL MODULE: ./src/modules/user/hooks/useUserQuery.ts
var useUserQuery = __webpack_require__(44320);
// EXTERNAL MODULE: ./vendor/hooks/useDispatchAction.ts
var useDispatchAction = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/store/actions.ts + 1 modules
var actions = __webpack_require__(88776);
// EXTERNAL MODULE: ./src/modules/modals/types/index.ts
var types = __webpack_require__(23025);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageAgendaSection/index.tsx

function EventPageAgendaSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 0 34px;\n  background: ",
        ";\n  ",
        " {\n    padding: 54px 0 76px;\n  }\n"
    ]);
    EventPageAgendaSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageAgendaSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1020px;\n"
    ]);
    EventPageAgendaSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageAgendaSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 855px;\n  padding: 0 !important;\n"
    ]);
    EventPageAgendaSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var EventPageAgendaSection_Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "EventPageAgendaSection__Section",
    componentId: "sc-f0651647-0"
})(EventPageAgendaSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageAgendaSection_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageAgendaSection__Container",
    componentId: "sc-f0651647-1"
})(EventPageAgendaSection_templateObject1());
var EventPageAgendaSection_ContentContainer = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPageAgendaSection__ContentContainer",
    componentId: "sc-f0651647-2"
})(EventPageAgendaSection_templateObject2());
var EventPageAgendaSection = (0,reactQuery/* withQueries */.kS)({
    data: useEventAgendaQuery/* useCurrentEventAgendaQuery */.J2
}, function(param) {
    var data = param.data;
    var event = (0,react.useContext)(EventPageContext/* EventPageContext */.P).event;
    var schedule = useEventAgendaSchedule(data, event.id);
    var user = (0,useUserQuery/* useUserQuery */.b)();
    var router = (0,next_router.useRouter)();
    var openModals = (0,es/* useSelector */.v9)(function(s) {
        return s.modals.openModals;
    });
    var openModal = (0,useDispatchAction/* useDispatchAction */.W)(actions/* AppAction.modalOpen */.q.modalOpen);
    (0,react.useEffect)(function() {
        if (!user.data && !user.isLoading && router.query.ticket) {
            openModal({
                kind: "authorization",
                mode: types/* AuthorizationModalMode.Login */.u.Login
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user.isLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToViewport/* ScrollToViewport */.v, {
        active: !!router.query.ticket && !!user.data && !openModals.length,
        options: true,
        scrollOnMount: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaSection_Section, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageAgendaSection_Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaHeader, {
                        schedule: schedule,
                        agenda: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaSection_ContentContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaSchedule, {
                            schedule: schedule
                        })
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./src/modules/events/components/EventPage/EventPageSEO.tsx
var EventPageSEO = __webpack_require__(9059);
// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuContext.tsx
var StickyMenuContext = __webpack_require__(95175);
// EXTERNAL MODULE: ./src/components/common/StickyMenu/StickyMenuSection.tsx
var StickyMenuSection = __webpack_require__(226);
// EXTERNAL MODULE: ./src/components/common/Skeleton.tsx
var Skeleton = __webpack_require__(47536);
// EXTERNAL MODULE: ./vendor/mods/media-breakpoints-fresnel/components/Media.tsx
var Media = __webpack_require__(50696);
;// CONCATENATED MODULE: ./src/modules/events/components/EventPage/EventPageHeaderSection/EventPageHeaderPlaceholder.tsx

function EventPageHeaderPlaceholder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 404px;\n  background: ",
        ";\n  ",
        " {\n    min-height: 528px;\n    ",
        " {\n      max-width: 1100px;\n      height: 100%;\n    }\n  }\n"
    ]);
    EventPageHeaderPlaceholder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPageHeaderPlaceholder_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-top: 10px;\n  padding-bottom: 30px;\n  ",
        " {\n    padding-bottom: 70px;\n  }\n"
    ]);
    EventPageHeaderPlaceholder_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPageHeaderPlaceholder_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 16px;\n  * {\n    max-width: 240px;\n  }\n  ",
        " {\n    flex-direction: column;\n    gap: 10px;\n  }\n"
    ]);
    EventPageHeaderPlaceholder_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPageHeaderPlaceholder_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 18px;\n  gap: 20px;\n  ",
        " {\n    flex-direction: row;\n    padding-bottom: 42px;\n    align-items: center;\n  }\n"
    ]);
    EventPageHeaderPlaceholder_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPageHeaderPlaceholder_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n"
    ]);
    EventPageHeaderPlaceholder_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPageHeaderPlaceholder_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  gap: 12px;\n  & > div {\n    margin: 0 !important;\n  }\n  ",
        " {\n    justify-content: flex-end;\n    & > div {\n      width: 60px;\n      height: 60px;\n    }\n  }\n"
    ]);
    EventPageHeaderPlaceholder_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var Wrapper = styled_components_browser_esm["default"].header.withConfig({
    displayName: "EventPageHeaderPlaceholder__Wrapper",
    componentId: "sc-944b5b6c-0"
})(EventPageHeaderPlaceholder_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, ConstraintContainer/* ConstraintContainer */.a);
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderPlaceholder__ContentWrapper",
    componentId: "sc-944b5b6c-1"
})(EventPageHeaderPlaceholder_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ActionsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderPlaceholder__ActionsContainer",
    componentId: "sc-944b5b6c-2"
})(EventPageHeaderPlaceholder_templateObject2(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageHeaderPlaceholder_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderPlaceholder__Header",
    componentId: "sc-944b5b6c-3"
})(EventPageHeaderPlaceholder_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPageHeaderPlaceholder_Details = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderPlaceholder__Details",
    componentId: "sc-944b5b6c-4"
})(EventPageHeaderPlaceholder_templateObject4());
var CountdownWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageHeaderPlaceholder__CountdownWrapper",
    componentId: "sc-944b5b6c-5"
})(EventPageHeaderPlaceholder_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPageHeaderPlaceholder = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConstraintContainer/* ConstraintContainer */.a, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderPlaceholder_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* Media */.pU, {
                                        greaterThanOrEqual: "desktop",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderPlaceholder_Details, {
                                            style: {
                                                marginRight: 30
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: 70,
                                                    height: 20
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: 80,
                                                    height: 40
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                    width: 60,
                                                    height: 20
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPageHeaderPlaceholder_Details, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                width: 140,
                                                height: 32
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                width: 160,
                                                height: 32
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                                width: 200,
                                                height: 32
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                        width: "30vw",
                                        height: 42
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                            width: "30vw",
                                            height: 42
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                width: 80,
                                height: 80
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                width: 80,
                                height: 80
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                width: 80,
                                height: 80
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/modules/events/hooks/useEventDetailsQuery.ts + 1 modules
var useEventDetailsQuery = __webpack_require__(43969);
;// CONCATENATED MODULE: ./src/modules/events/templates/EventPageTemplate.tsx

function EventPageTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    EventPageTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var OrderContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPageTemplate__OrderContainer",
    componentId: "sc-b77b20d6-0"
})(EventPageTemplate_templateObject());
var EventPageTemplate = function(param) {
    var slug = param.slug;
    var ref = (0,useEventDetailsQuery/* useEventDetailsQuery */.U)(slug), event = ref.data, isLoading = ref.isLoading;
    if (!event || isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeaderPlaceholder, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageContext/* EventPageContextProvider */.j, {
        event: event,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuContext/* StickyMenuProvider */.Q, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSEO/* EventPageSEO */.d, {
                    event: event
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyMenuSection/* StickyMenuSection */.T, {
                    id: EventPageSection.About,
                    threshold: 0.2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHeaderSection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAboutSection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageHowToParticipate, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageVideoPlayer, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenuSection/* StickyMenuSection */.T, {
                    id: EventPageSection.Agenda,
                    threshold: 0.5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageAgendaSection, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenuSection/* StickyMenuSection */.T, {
                    id: EventPageSection.Speakers,
                    threshold: 0.5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageSpeakersSection, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenuSection/* StickyMenuSection */.T, {
                    id: EventPageSection.RelatedVideos,
                    threshold: 0.75,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageRelatedVideosSection, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyMenuSection/* StickyMenuSection */.T, {
                    id: EventPageSection.FAQ,
                    threshold: 0.2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPageFAQSection, {})
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-sitemap.query.ts

function events_sitemap_query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query EventsSitemapList {\n    events(filter: { status: { _eq: "published" } }, limit: -1) {\n      slug\n      date_created\n      date_updated\n    }\n  }\n'
    ]);
    events_sitemap_query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventsSitemapGqlQuery = (0,gql_query/* gql */.Ps)(events_sitemap_query_templateObject());

// EXTERNAL MODULE: ./src/services/directus/common.ts
var directus_common = __webpack_require__(6050);
;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventsSitemapQuery.ts






var fetchSitemapEvents = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,directus_common/* fetchPublicDirectusGqlItems */.S2)(eventsSitemapGqlQuery).then(function(a) {
                    return a.events;
                })
            ];
        });
    });
    return function fetchSitemapEvents() {
        return _ref.apply(this, arguments);
    };
}();
var useEventsSitemapQuery = function() {
    return useQuery(QueryKey.EventsSitemap, fetchSitemapEvents);
};

;// CONCATENATED MODULE: ./src/pages/events/[slug]/index.tsx





var __N_SSP = true;
function getSitemap() {
    return _getSitemap.apply(this, arguments);
}
function _getSitemap() {
    _getSitemap = (0,_async_to_generator/* default */.Z)(function() {
        var events, _date_updated;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchSitemapEvents()
                    ];
                case 1:
                    events = _state.sent();
                    return [
                        2,
                        events.map(function(event) {
                            return {
                                loc: route/* route.event */.BC.event(event).page(),
                                lastmod: (_date_updated = event.date_updated) !== null && _date_updated !== void 0 ? _date_updated : event.date_created,
                                priority: 0.8
                            };
                        })
                    ];
            }
        });
    });
    return _getSitemap.apply(this, arguments);
}
/* harmony default export */ var _slug_ = (EventPageTemplate);


/***/ }),

/***/ 33403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ publicUrl; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);

var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
/**
 * Gets an asset path taking in account a basePath if it is set
 * @param uri
 */ function publicUrl(uri) {
    return publicRuntimeConfig.basePath ? uri.replace(/^\//, publicRuntimeConfig.basePath.replace(/\/?$/, "/")) : uri;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5689,78,8554,8999,8281,4732,2560,9774,2888,179], function() { return __webpack_exec__(40332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);